
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAntennaOff as ObiAntennaOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-antenna-off.js';
 
 
 

 
 export const ObiAntennaOff = createComponent({
   react: React,
   tagName: 'obi-antenna-off',
   elementClass: ObiAntennaOffElement,
   events: {
     
   }
  });
 
 